import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-3" }
const _hoisted_5 = { class: "col-6 col-md-3" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-6 col-md-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-6 col-md-3" }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = { class: "col-md-12 table-responsive" }
const _hoisted_12 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_13 = { class: "nowrap-celular" }
const _hoisted_14 = { class: "text-lowercase" }
const _hoisted_15 = { class: "text-center text-nowrap" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-12 fw-bold fs-6 mb-3" }
const _hoisted_24 = { class: "col-md-12 mb-2" }
const _hoisted_25 = { class: "col-md-12" }
const _hoisted_26 = { class: "col-md-12 mt-2" }
const _hoisted_27 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_28 = {
  key: 1,
  class: "alert alert-success"
}

import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as serviceUsuarios from "@/services/usuariosService";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import ImgUsuario from "@/components/Imagens/ImgUsuario.vue";
  import MsgBox from "@/components/MsgBox/Index.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  var controle = reactive({
    filtros: {
      statusId: null,
      tipoId: null,
      paginaAtual: 1,
      tamanhoPagina: 10
    } as unknown as serviceUsuarios.UsuarioFiltros,
    itens: [] as serviceUsuarios.Usuario[],

    tipos: [] as serviceUsuarios.UsuarioTipo[],
    listaStatus:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},       
      {valor: false, descricao:"Inativos"},
    ],
    itemExcluir: null as serviceUsuarios.Usuario | null,
    janExcluir: false,

    itemAlterarSenha: null as serviceUsuarios.Usuario | null,
    janAlterarSenha: false,
    formSenha: {
      senhaNova: '',
      confirmaNovaSenha: '',
    },

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    controle.tipos = await serviceUsuarios.obterTipos();
    pesquisar();
  })

  async function pesquisar() {

    serviceUsuarios.obter(controle.filtros)
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function defineTipo(tipoId: number | undefined) {
    var tipo = controle.tipos.find(t => t.tipoId === tipoId);
    if (tipo) {
      return tipo.descricao; 
    } else {
      return "Desconhecido";  
    }
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

  function abrirAlterarSenha(item: serviceUsuarios.Usuario) {
    controle.itemAlterarSenha = item;
    controle.formSenha.senhaNova = '';
    controle.formSenha.confirmaNovaSenha = '';
    controle.janAlterarSenha = true;
  }

  function confirmarAlterarSenha() {
    if (!controle.itemAlterarSenha) return;
    controle.status = "Alterando senha...";
    controle.erro = "";
    serviceUsuarios.alterarSenha(
      controle.itemAlterarSenha.usuarioId,
      controle.formSenha.senhaNova,
      controle.formSenha.confirmaNovaSenha
    )
    .then(() => {
      controle.status = "Senha alterada com sucesso!";
      setTimeout(() => {
        controle.janAlterarSenha = false;
        controle.status = "";
      }, 3000);
    })
    .catch(erro => {
      controle.erro = erro;
      controle.status = "";
    });
  }

  function pergExcluir(item: serviceUsuarios.Usuario) {
    controle.janExcluir = true;
    controle.itemExcluir = item;
  }

  function excluir() {
    if (controle.itemExcluir) {
      serviceUsuarios.excluir(controle.itemExcluir.usuarioId!)
        .then(() => {
          controle.janExcluir = false;
          pesquisar();
        })
        .catch(erro => {
          controle.erro = erro;
          controle.janExcluir = false;
        });
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Usuários" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Nome, email...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
              onKeyup: pesquisar
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.nome]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Tipo", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.tipoId) = $event)),
              onChange: pesquisar
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "- Todos -", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).tipos, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.tipoId,
                  key: item.tipoId
                }, _toDisplayString(item.descricao), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.tipoId]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.ativo) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaStatus, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.valor,
                  key: idx
                }, _toDisplayString(item.descricao), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.ativo]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-primary btn-sm mt-4 float-end",
              to: '/usuarios/cadastro'
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "flaticon-plus" }, null, -1),
                _createTextVNode(" Adicionar", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (ordenarPor('usuarioId'))),
                    class: "th-sortable"
                  }, "Id"),
                  _createElementVNode("th", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (ordenarPor('nomeCompleto'))),
                    class: "th-sortable"
                  }, "Usuário"),
                  _createElementVNode("th", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('tipoId'))),
                    class: "th-sortable"
                  }, "Tipo"),
                  _createElementVNode("th", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('email'))),
                    class: "th-sortable"
                  }, "Email"),
                  _createElementVNode("th", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('ativo'))),
                    class: "th-sortable"
                  }, "Status"),
                  _cache[20] || (_cache[20] = _createElementVNode("th", null, "Opções", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.usuarioId), 1),
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(ImgUsuario, {
                        usuarioId: item.usuarioId,
                        alt: item.nomeCompleto
                      }, null, 8, ["usuarioId", "alt"]),
                      _createTextVNode(" " + _toDisplayString(item.nomeCompleto), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(defineTipo(item.tipoId)), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", item.ativo ? 'badge-soft-success' : 'badge-soft-danger'])
                      }, _toDisplayString(item.ativo ? 'Ativo' : 'Inativo'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_RouterLink, {
                          to: '/usuarios/cadastro/' + item.usuarioId
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (abrirAlterarSenha(item)),
                          title: "Alterar Senha"
                        }, [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("i", { class: "flaticon-lock fs-5 text-warning" }, null, -1)
                        ]))], 8, _hoisted_16),
                        _createElementVNode("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (pergExcluir(item))
                        }, [...(_cache[23] || (_cache[23] = [
                          _createElementVNode("i", { class: "flaticon-delete fs-5 text-danger" }, null, -1)
                        ]))], 8, _hoisted_17)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(controle).itens.length) + " Registros ", 1),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: _unref(controle).filtros.paginaAtual,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina,
              totalItens: _unref(controle).itens.length,
              onOnChange: _cache[8] || (_cache[8] = (el) => { 
              _unref(controle).filtros.paginaAtual = el.paginaAtual; 
              _unref(controle).filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar() })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalItens"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: '/'
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: 'janExcluir',
      titulo: 'Atenção',
      exibir: _unref(controle).janExcluir,
      onOnFechou: _cache[9] || (_cache[9] = ($event: any) => (_unref(controle).janExcluir = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[10] || (_cache[10] = ($event: any) => (excluir()))
    }, {
      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-12 fw-bold fs-6" }, " Deseja excluir este registro? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"]),
    _createVNode(MsgBox, {
      id: 'janAlterarSenha',
      titulo: 'Alterar Senha',
      tamanho: 'modal-sm',
      exibir: _unref(controle).janAlterarSenha,
      onOnFechou: _cache[13] || (_cache[13] = ($event: any) => (_unref(controle).janAlterarSenha = false)),
      "botao-gravar": true,
      "botao-fechar": true,
      onOnGravar: _cache[14] || (_cache[14] = ($event: any) => (confirmarAlterarSenha()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(controle).itemAlterarSenha?.nomeCompleto), 1),
          _createElementVNode("div", _hoisted_24, [
            _cache[26] || (_cache[26] = _createElementVNode("label", null, "Nova Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).formSenha.senhaNova) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formSenha.senhaNova]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[27] || (_cache[27] = _createElementVNode("label", null, "Confirmar Nova Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(controle).formSenha.confirmaNovaSenha) = $event))
            }, null, 512), [
              [_vModelText, _unref(controle).formSenha.confirmaNovaSenha]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            (_unref(controle).erro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(controle).erro), 1))
              : _createCommentVNode("", true),
            (_unref(controle).status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(controle).status), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})